import { createStyles, makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textAlign: 'right',
      userSelect: 'none'
    },
    language: {
      cursor: 'pointer',
      paddingLeft: '0.3rem',
      lineHeight: '100%',
      display: 'inline-block',
      '&:not(:last-child)': {
        borderRight: '1px solid red',
        paddingRight: '0.3rem'
      }
    },
    inactive: {
      color: '#C0C0C0'
    },
    active: {
      color: '#000000'
    }
  })
)
